import React from "react";
import MasterDataFormV2 from "../../MasterDataFormV2";

const CreateTeamPage = ({ initialData, onSuccess, onError }) => {
  const fields = [
    {
      name: "photo",
      label: "Photo",
      type: "file",
    },
    {
      name: "name",
      label: "Full Name",
      type: "text",
    },
    {
      name: "nickname",
      label: "Nickname",
      type: "text",
    },
    {
      name: "username",
      label: "Username",
      type: "text",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
    },
    {
      name: "whatsapp",
      label: "WhatsApp",
      type: "tel",
    },
    {
      name: "role",
      label: "Role",
      type: "select",
      options: [
        { value: "Manager", label: "Manager" },
        { value: "Developer", label: "Developer" },
        { value: "Designer", label: "Designer" },
        { value: "HR Specialist", label: "HR Specialist" },
        { value: "Accountant", label: "Accountant" },
        { value: "Marketing", label: "Marketing" },
        { value: "Sales", label: "Sales" },
        { value: "Support", label: "Support" },
      ],
    },
  ];

  return (
    <MasterDataFormV2
      apiUrl="/hr/team"
      initialData={initialData}
      fields={fields}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default CreateTeamPage;
